import { Dialog } from '@datacamp/waffles/dialog';
import { Paragraph } from '@datacamp/waffles/paragraph';
import React from 'react';

import floatingPaneGif from '../../assets/images/floating_pane.gif';

import GuidesBackButton from './GuidesBackButton';

const InteractingWithFloatingPaneModal: React.FC = () => {
  return (
    <>
      <Dialog.Header>
        Interacting with the floating instruction pane
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          If you are accessing BI courses using a small screen, the floating
          instruction pane functionality will be enabled. This will ensure that
          there is enough space available to display the software. You can
          collapse the pane by clicking anywhere in the VM screen on the right.
          Similarly, you can expand the pane again by clicking the arrow in the
          top right corner of the instructions pane.
        </Paragraph>
        <img
          alt="The instruction pane floating over the VM area"
          height="auto"
          src={floatingPaneGif}
          style={{ marginTop: 16 }}
          width="100%"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <GuidesBackButton />
      </Dialog.Footer>
    </>
  );
};

export default InteractingWithFloatingPaneModal;
